export default {
  en: {
    intro: "The ultimate representation of this class is a choice of exactly one of the classes in the following set:",
    Type: "Type",
    Description: "Description"
  },
  es: {
    intro: "La representación definitiva de esta clase es exactamente una de las siguientes clases:",
    Type: "Tipo",
    Description: "Descripción"
  },
  ca: {
    intro: "La representació definitiva d'aquesta classe és exactament una de les següents classes:",
    Type: "Tipus",
    Description: "Descripció"
  }
};
